var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeworreturninguser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    role: "img",
    width: 40,
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "m19.059 10.898l-3.171-7.927A1.543 1.543 0 0 0 14.454 2H5.546c-.632 0-1.2.384-1.434.971L.941 10.898a4.25 4.25 0 0 0-.246 2.272l.59 3.539A1.544 1.544 0 0 0 2.808 18h14.383c.755 0 1.399-.546 1.523-1.291l.59-3.539a4.22 4.22 0 0 0-.245-2.272zM5.52 4.786l1.639-1.132l2.868 2.011l2.868-2.011l1.639 1.132l-2.869 2.033l2.928 2.06l-1.639 1.171l-2.927-2.076L7.1 10.05L5.461 8.879l2.928-2.06L5.52 4.786zm11.439 10.459a.902.902 0 0 1-.891.755H3.932a.902.902 0 0 1-.891-.755l-.365-2.193A.902.902 0 0 1 3.567 12h12.867c.558 0 .983.501.891 1.052l-.366 2.193z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeworreturninguser);
export default __webpack_public_path__ + "static/media/neworreturninguser.b5ddcee9899545882ed771d8aaa786f3.svg";
export { ForwardRef as ReactComponent };